module.exports = __webpack_public_path__ + "img/901668095.9f6dc883.png";